import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import ROUTERS_PATHS from 'consts/router-paths';
import Icons from 'consts/svgIcons';
import useAuth from 'contexts/useAuth';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetUserState } from 'redux/user/userSlice';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styled from '@emotion/styled';
import { MenuProps } from 'react-select';
import styles from './styles.module.scss';

const StyledMenu = styled((props: any) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    width:80,
    marginLeft: 30,
    '& .MuiMenu-list': {
      padding: '0px 5px 0px 5px',
      display:'flex',
      alignItems:'center',
      justifyContent:'center'
    },
  },
}));

function Header() {
  const { logout } = useAuth();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [openMenu, setOpenMenu] = React.useState<boolean>(false);
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  const user = useGetUserState();
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorElUser(null);
  };

  const handleLogout = (event: React.MouseEvent<HTMLElement>) => {
    handleCloseUserMenu(event);
    logout();
  };

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(true);
  };

  const handleClose = () => {
    setOpenMenu(false);
    setAnchorEl(null);
  };
  const navigate = useNavigate();

  return (
    <AppBar
      position="fixed"
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      className={styles.header}>
      <Container maxWidth={false} className={styles.container}>
        <Toolbar disableGutters className={styles.toolbar}>
          <Box display="flex" alignItems="center">
            <div className={styles.logoContainer}>
              <Icons.BuildcorpLogoWhite
                className={styles.logoIcon}
                onClick={() => navigate(ROUTERS_PATHS.DASHBOARD)}
              />
            </div>
          </Box>
          <Box component="div" className={styles.userContainer}>
            <a
              className={styles.menuHeader}
              style={{ color: '#fff', textDecoration: 'none' }}
              href={ROUTERS_PATHS.DASHBOARD}>
              Knowledge Base
            </a>
            <Box display={'flex'} sx={{ alignItems: 'center' }}>
              <Typography sx={{ color: '#69BE28' }} className={styles.menuHeader}>
                {user?.displayName}
              </Typography>
              <IconButton sx={{ paddingRight: 0 }} onClick={(e) => handleOpenMenu(e)}>
                <ExpandMoreIcon sx={{ color: 'white' }} />
              </IconButton>
            </Box>

            <StyledMenu
              id="basic-menu"
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              anchorEl={anchorEl}
              open={openMenu}
              onClose={handleClose}>
              <MenuItem style={{paddingLeft:7,paddingRight:7}}>
                <Typography className={styles.menuHeader} color="#9E9E9E ," onClick={handleLogout}>
                  Log out
                </Typography>
              </MenuItem>
            </StyledMenu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default Header;
